import { useEffect, useRef } from 'react';

/**
 * Returns true once the given dependency becomes truthy.
 * Stays true thereafter — useful for suppressing animations on initial load
 * while enabling them for subsequent changes.
 */
export function useHasLoaded(dep: unknown): boolean {
  const loaded = useRef(false);

  useEffect(() => {
    if (dep) loaded.current = true;
  }, [dep]);

  return loaded.current;
}
